module.exports = __webpack_public_path__ + "static/img/14-05.1c1fb18.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award/14-05.png
// module id = XxL/
// module chunks = 1